import { render } from "./SendPendingArtworks.vue?vue&type=template&id=64b4077a&scoped=true"
import script from "./SendPendingArtworks.vue?vue&type=script&lang=js"
export * from "./SendPendingArtworks.vue?vue&type=script&lang=js"

import "./SendPendingArtworks.vue?vue&type=style&index=0&id=64b4077a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b4077a"]])

export default __exports__